/* eslint-disable import/extensions */
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from 'bernie-view';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { useLocalization } from '@shared-ui/localization-context';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { OnChangeFn, OnSubmitFn } from './action-provider';
import { SharedUiDateFieldWrapper, SharedUiTravelersWrapper } from './field-wrappers';
import { SharedUiFormWrapper } from './form-wrapper';
import { SharedUiSingleOfferSearchButtonWrapper } from 'components/infosite/shared-ui/offers/single-offer-search-button-wrapper';
import { SharedUiTravelersSelectorWrapper } from '../offers/shared-ui-traveler-selector-wrapper';

const DatedForm: React.FC<{ l10nKey: string }> = ({ l10nKey }) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutFlex space="three">
      <UitkLayoutFlexItem grow={4}>
        <div>
          <SharedUiDateFieldWrapper buttonText={formatText(l10nKey)} />
        </div>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem grow={3}>
        <div>
          <Experiment name="Vrbex_traveler_selector">
            <ExperimentControl>
              <SharedUiTravelersWrapper closeOnSubmit={false} />
            </ExperimentControl>
            <ExperimentVariant bucket={1}>
              <SharedUiTravelersSelectorWrapper />
            </ExperimentVariant>
          </Experiment>
        </div>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};

export const SharedUiDatedForm: React.FC<{ onChange?: OnChangeFn }> = ({ onChange }) => {
  const location = useLocation();

  return (
    <ErrorBoundary label="shared-ui-dated-form">
      <SharedUiFormWrapper action={location.pathname} onChange={onChange}>
        <DatedForm l10nKey={'hotels.infosite.searchForm.availabilityButton.label'} />
      </SharedUiFormWrapper>
    </ErrorBoundary>
  );
};
SharedUiDatedForm.displayName = 'SharedUiDatedForm';

export const SharedUiSingleUnitForm: React.FC<{
  onChange?: OnChangeFn;
  onSubmit?: OnSubmitFn;
}> = ({ onChange, onSubmit }) => {
  const location = useLocation();
  const { formatText } = useLocalization();

  return (
    <SharedUiFormWrapper action={location.pathname} onChange={onChange} onSubmit={onSubmit}>
      <UitkLayoutFlex direction="column" space="three">
        <UitkLayoutFlexItem>
          <div>
            <SharedUiDateFieldWrapper buttonText={formatText('hotels.infosite.searchForm.availabilityButton.label')} closeOnSubmit={true} />
          </div>
        </UitkLayoutFlexItem>
        <Experiment name="PWA_VR_Get_Single_unit_in_Multi_room_search">
          <ExperimentControl>
            <UitkLayoutFlexItem>
              <div>
                <Experiment name="Vrbex_traveler_selector">
                  <ExperimentControl>
                    <SharedUiTravelersWrapper closeOnSubmit={false} isSingleUnit />
                  </ExperimentControl>
                  <ExperimentVariant bucket={1}>
                    <SharedUiTravelersSelectorWrapper />
                  </ExperimentVariant>
                </Experiment>
              </div>
            </UitkLayoutFlexItem>
          </ExperimentControl>
          <ExperimentVariant bucket={1} />
        </Experiment>
        <Experiment name="Vrbex_Availability_Date_Selector">
          <ExperimentControl>
            <UitkLayoutFlexItem>
              <SharedUiSingleOfferSearchButtonWrapper />
            </UitkLayoutFlexItem>
          </ExperimentControl>
          <ExperimentVariant bucket={1}>
            <></>
          </ExperimentVariant>
        </Experiment>
      </UitkLayoutFlex>
    </SharedUiFormWrapper>
  );
};
SharedUiSingleUnitForm.displayName = 'SharedUiSingleUnitForm';
